import { RepeatOneSharp } from "@mui/icons-material";
import axios from "axios";



export const getProfessions = async () => {
    try {
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API}/professions`,
          headers: { "Content-Type": "application/json" },
        });
        const professions = []
        for (const profession of response.data) {
          const obj = {
            value: profession._id,
            label: profession.title
          }
          professions.push(obj)
        }
         return professions;
      } catch (e) {
        return false
      }
}